module.exports = __webpack_public_path__ + "static/clouds-165af0a4abd8eba49a3655b5b061128f.png";